import { render, staticRenderFns } from "./ProductMovementModal.vue?vue&type=template&id=4de5e55a"
import script from "./ProductMovementModal.vue?vue&type=script&lang=js"
export * from "./ProductMovementModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports